// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elc-dashboard-container {
  padding: 0;
}

.elc-cardbody {
  padding: 7px 14px 7px 14px;
  display: flex;
  align-items: start;
  justify-content: space-around;
  flex-direction: column;
}

.elc-tile-title {
  font-size: 14px;
  color: #404653;
  font-weight: 500;
}

.elc-tile-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
}

.elc-calendar-dropdown {
  display: flex;
  flex-direction: row;
  justify-content: between;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  border-color: #d3d3d3;
  font-size: 12px;
  height: 27px;
}

.elc-calendar-menu {
  width: 500px;
}

.elc-calendar-dropdown:hover {
  border-color: #d3d3d3;
  background-color: #fff;
}

.approved-count-circle {
  background-color: #ddf4ea;
  color: #26b97a;
}

.approved-count {
  font-weight: 500;
  color: #26b97a;
}

.pending-count-circle {
  background-color: #faf0dd;
  color: #de9918;
}

.pending-count {
  font-weight: 500;
  color: #de9918;
}

.rejected-count-circle {
  background-color: #f8deda;
  color: #d22109;
}

.rejected-count {
  font-weight: 500;
  color: #d22109;
}

.revised-count-circle {
  background-color: #dae6f3;
  color: #0a56ae;
}

.revised-count {
  font-weight: 500;
  color: #0a56ae;
}

.backout-count-circle {
  background-color: #dcdcdc;
  color: #000;
}

.sla-count {
  font-weight: 500;
  color: #7F00FF;
}

.sla-count-circle {
  background-color: #ded1ec;
  color: #7F00FF;
}

.approved-count-circle,
.backout-count-circle,
.pending-count-circle,
.rejected-count-circle,
.revised-count-circle,
.sla-count-circle {
  height: 23px;
  width: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.backout-count {
  font-weight: 500;
  color: #000;
}

.elc-check-icon,
.elc-pending-icon,
.elc-rejected-icon,
.elc-revised-icon,
.elc-backout-icon,
.elc-alert-icon {
  font-size: 14px;
}

.approved-count,
.backout-count,
.pending-count,
.rejected-count,
.revised-count,
.sla-count {
  font-size: 14px;
}

.pre-offer-verification-item {
  grid-area: pre-offer-verification-item;
}

.offer-creation-item {
  grid-area: offer-creation-item;
}

.offer-review-item {
  grid-area: offer-review-item;
}

.offer-approval-item {
  grid-area: offer-approval-item;
}

.share-offer-item {
  grid-area: share-offer-item;
}

.offer-status-item {
  grid-area: offer-status-item;
}

.clearance-item {
  grid-area: clearance-item;
}

.onboard-item {
  grid-area: onboard-item;
}

.offer-revise-item {
  grid-area: offer-revise-item;
}

.vendor-item {
  grid-area: vendor-item;
}

.renewal-item {
  grid-area: renewal-item;
}

.exit-item {
  grid-area: exit-item;
}

.elc-grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-template-areas: "pre-offer-verification-item pre-offer-verification-item offer-creation-item offer-creation-item offer-review-item offer-review-item offer-approval-item offer-approval-item share-offer-item share-offer-item" "offer-status-item offer-status-item offer-status-item offer-status-item clearance-item clearance-item clearance-item clearance-item onboard-item onboard-item" "offer-revise-item offer-revise-item vendor-item vendor-item clearance-item clearance-item clearance-item clearance-item renewal-item exit-item";
  grid-gap: 10px;
}

.elc-title-icon {
  height: 23px;
}

.elc-dashboard-title {
  font-size: 13px;
  font-weight: 500;
  color: #404653;
}

.resize {
  background-color: lightgoldenrodyellow;
  width: calc(100% + 24px);
  margin-left: -12px;
  height: 15px;
  cursor: row-resize;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.resize::before {
  content: "";
  position: absolute;
  right: 0;
}

@media (min-width: 1024px) {
  .elc-tile-title {
    font-size: 11px;
  }

  .approved-count-circle,
.backout-count-circle,
.pending-count-circle,
.rejected-count-circle,
.revised-count-circle,
.sla-count-circle {
    height: 20px;
    width: 20px;
  }

  .elc-approved-icon,
.elc-check-icon,
.elc-pending-icon,
.elc-rejected-icon,
.elc-revised-icon,
.elc-backout-icon,
.elc-alert-icon {
    font-size: 9px;
  }

  .approved-count,
.backout-count,
.pending-count,
.rejected-count,
.revised-count,
.sla-count {
    font-size: 11px;
  }

  .elc-title-icon {
    height: 19px;
  }
}
@media (min-width: 1366px) {
  .elc-tile-title {
    font-size: 14px;
  }

  .elc-dashboard-title {
    font-size: 15px;
    font-weight: 500;
    color: #404653;
  }

  .approved-count-circle,
.backout-count-circle,
.pending-count-circle,
.rejected-count-circle,
.revised-count-circle,
.sla-count-circle {
    height: 23px;
    width: 23px;
  }

  .elc-approved-icon,
.elc-check-icon,
.elc-pending-icon,
.elc-rejected-icon,
.elc-revised-icon,
.elc-backout-icon,
.elc-alert-icon {
    font-size: 11px;
  }

  .approved-count,
.backout-count,
.pending-count,
.rejected-count,
.revised-count,
.sla-count {
    font-size: 13px;
  }

  .elc-title-icon {
    height: 19px;
    padding-right: 5px;
  }
}
@media (min-width: 1920px) {
  .elc-tile-title {
    font-size: 15px;
  }

  .approved-count-circle,
.backout-count-circle,
.pending-count-circle,
.rejected-count-circle,
.revised-count-circle,
.sla-count-circle {
    height: 23px;
    width: 23px;
  }

  .elc-approved-icon,
.elc-check-icon,
.elc-pending-icon,
.elc-rejected-icon,
.elc-revised-icon,
.elc-backout-icon,
.elc-alert-icon {
    font-size: 15px;
  }

  .approved-count,
.backout-count,
.pending-count,
.rejected-count,
.revised-count,
.sla-count {
    font-size: 15px;
  }

  .elc-title-icon {
    height: 19px;
  }

  .elc-dashboard-title {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./../dashboard/src/pages/Dashboard/ELCDashboard.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAEA;EACE,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EAEA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,qBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF;;AAGA;;;;;;EAME,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;AAAF;;AAGA;;;;;;EAME,eAAA;AAAF;;AAGA;;;;;;EAME,eAAA;AAAF;;AAKA;EACE,sCAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sCAAA;EACA,kCAAA;EACA,qhBACE;EAGF,cAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALF;;AAQA;EACE,sCAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;AALF;;AASA;EACE;IACE,eAAA;EANF;;EASA;;;;;;IAME,YAAA;IACA,WAAA;EANF;;EASA;;;;;;;IAOE,cAAA;EANF;;EASA;;;;;;IAME,eAAA;EANF;;EASA;IACE,YAAA;EANF;AACF;AASA;EACE;IACE,eAAA;EAPF;;EAUA;IACE,eAAA;IACA,gBAAA;IACA,cAAA;EAPF;;EAUA;;;;;;IAME,YAAA;IACA,WAAA;EAPF;;EAUA;;;;;;;IAOE,eAAA;EAPF;;EAUA;;;;;;IAME,eAAA;EAPF;;EAUA;IACE,YAAA;IACA,kBAAA;EAPF;AACF;AAUA;EACE;IACE,eAAA;EARF;;EAWA;;;;;;IAME,YAAA;IACA,WAAA;EARF;;EAWA;;;;;;;IAOE,eAAA;EARF;;EAWA;;;;;;IAME,eAAA;EARF;;EAWA;IACE,YAAA;EARF;;EAWA;IACE,eAAA;EARF;AACF","sourcesContent":[".elc-dashboard-container {\n  padding: 0;\n}\n\n.elc-cardbody {\n  padding: 7px 14px 7px 14px;\n  display: flex;\n  align-items: start;\n  justify-content: space-around;\n  flex-direction: column;\n}\n\n.elc-tile-title {\n  font-size: 14px;\n  color: #404653;\n  font-weight: 500;\n}\n\n.elc-tile-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n}\n\n.elc-calendar-dropdown {\n  display: flex;\n  flex-direction: row;\n  justify-content: between;\n  align-items: center;\n  width: 100%;\n\n  background-color: #fff;\n  border-radius: 4px;\n  padding: 8px;\n  cursor: pointer;\n  border-color: #d3d3d3;\n  font-size: 12px;\n  height: 27px;\n}\n\n.elc-calendar-menu {\n  width: 500px;\n}\n\n.elc-calendar-dropdown:hover {\n  border-color: #d3d3d3;\n  background-color: #fff;\n}\n\n.approved-count-circle {\n  background-color: #ddf4ea;\n  color: #26b97a;\n}\n\n.approved-count {\n  font-weight: 500;\n  color: #26b97a;\n}\n\n.pending-count-circle {\n  background-color: #faf0dd;\n  color: #de9918;\n}\n\n.pending-count {\n  font-weight: 500;\n  color: #de9918;\n}\n\n.rejected-count-circle {\n  background-color: #f8deda;\n  color: #d22109;\n}\n\n.rejected-count {\n  font-weight: 500;\n  color: #d22109;\n}\n\n.revised-count-circle {\n  background-color: #dae6f3;\n  color: #0a56ae;\n}\n\n.revised-count {\n  font-weight: 500;\n  color: #0a56ae;\n}\n\n.backout-count-circle {\n  background-color: #dcdcdc;\n  color: #000;\n}\n\n.sla-count {\n  font-weight: 500;\n  color: #7F00FF;\n}\n\n.sla-count-circle {\n  background-color: #ded1ec;\n  color: #7F00FF;\n}\n\n.approved-count-circle,\n.backout-count-circle,\n.pending-count-circle,\n.rejected-count-circle,\n.revised-count-circle,\n.sla-count-circle {\n  height: 23px;\n  width: 23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.backout-count {\n  font-weight: 500;\n  color: #000;\n}\n\n.elc-check-icon,\n.elc-pending-icon,\n.elc-rejected-icon,\n.elc-revised-icon,\n.elc-backout-icon,\n.elc-alert-icon {\n  font-size: 14px;\n}\n\n.approved-count,\n.backout-count,\n.pending-count,\n.rejected-count,\n.revised-count,\n.sla-count {\n  font-size: 14px;\n}\n\n// Grid\n\n.pre-offer-verification-item {\n  grid-area: pre-offer-verification-item;\n}\n\n.offer-creation-item {\n  grid-area: offer-creation-item;\n}\n\n.offer-review-item {\n  grid-area: offer-review-item;\n}\n\n.offer-approval-item {\n  grid-area: offer-approval-item;\n}\n\n.share-offer-item {\n  grid-area: share-offer-item;\n}\n\n.offer-status-item {\n  grid-area: offer-status-item;\n}\n\n.clearance-item {\n  grid-area: clearance-item;\n}\n\n.onboard-item {\n  grid-area: onboard-item;\n}\n\n.offer-revise-item {\n  grid-area: offer-revise-item;\n}\n\n.vendor-item {\n  grid-area: vendor-item;\n}\n\n.renewal-item {\n  grid-area: renewal-item;\n}\n\n.exit-item {\n  grid-area: exit-item;\n}\n\n.elc-grid {\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n  grid-template-areas:\n    \"pre-offer-verification-item pre-offer-verification-item offer-creation-item offer-creation-item offer-review-item offer-review-item offer-approval-item offer-approval-item share-offer-item share-offer-item\"\n    \"offer-status-item offer-status-item offer-status-item offer-status-item clearance-item clearance-item clearance-item clearance-item onboard-item onboard-item\"\n    \"offer-revise-item offer-revise-item vendor-item vendor-item clearance-item clearance-item clearance-item clearance-item renewal-item exit-item\";\n  grid-gap: 10px;\n}\n\n.elc-title-icon {\n  height: 23px;\n}\n\n.elc-dashboard-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #404653;\n}\n\n.resize {\n  background-color: lightgoldenrodyellow;\n  width: calc(100% + 24px);\n  margin-left: -12px;\n  height: 15px;\n  cursor: row-resize;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 10;\n}\n\n.resize::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n}\n\n// Responsive\n@media (min-width: 1024px) {\n  .elc-tile-title {\n    font-size: 11px;\n  }\n\n  .approved-count-circle,\n  .backout-count-circle,\n  .pending-count-circle,\n  .rejected-count-circle,\n  .revised-count-circle,\n  .sla-count-circle {\n    height: 20px;\n    width: 20px;\n  }\n\n  .elc-approved-icon,\n  .elc-check-icon,\n  .elc-pending-icon,\n  .elc-rejected-icon,\n  .elc-revised-icon,\n  .elc-backout-icon,\n  .elc-alert-icon {\n    font-size: 9px;\n  }\n\n  .approved-count,\n  .backout-count,\n  .pending-count,\n  .rejected-count,\n  .revised-count,\n  .sla-count {\n    font-size: 11px;\n  }\n\n  .elc-title-icon {\n    height: 19px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .elc-tile-title {\n    font-size: 14px;\n  }\n\n  .elc-dashboard-title {\n    font-size: 15px;\n    font-weight: 500;\n    color: #404653;\n  }\n\n  .approved-count-circle,\n  .backout-count-circle,\n  .pending-count-circle,\n  .rejected-count-circle,\n  .revised-count-circle,\n  .sla-count-circle {\n    height: 23px;\n    width: 23px;\n  }\n\n  .elc-approved-icon,\n  .elc-check-icon,\n  .elc-pending-icon,\n  .elc-rejected-icon,\n  .elc-revised-icon,\n  .elc-backout-icon,\n  .elc-alert-icon {\n    font-size: 11px;\n  }\n\n  .approved-count,\n  .backout-count,\n  .pending-count,\n  .rejected-count,\n  .revised-count,\n  .sla-count {\n    font-size: 13px;\n  }\n\n  .elc-title-icon {\n    height: 19px;\n    padding-right: 5px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .elc-tile-title {\n    font-size: 15px;\n  }\n\n  .approved-count-circle,\n  .backout-count-circle,\n  .pending-count-circle,\n  .rejected-count-circle,\n  .revised-count-circle,\n  .sla-count-circle {\n    height: 23px;\n    width: 23px;\n  }\n\n  .elc-approved-icon,\n  .elc-check-icon,\n  .elc-pending-icon,\n  .elc-rejected-icon,\n  .elc-revised-icon,\n  .elc-backout-icon,\n  .elc-alert-icon {\n    font-size: 15px;\n  }\n\n  .approved-count,\n  .backout-count,\n  .pending-count,\n  .rejected-count,\n  .revised-count,\n  .sla-count {\n    font-size: 15px;\n  }\n\n  .elc-title-icon {\n    height: 19px;\n  }\n\n  .elc-dashboard-title {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
